import { useContext, useState, useEffect } from 'react'
import SocketContext from 'context/context'
import { useSelector } from 'react-redux'

const PRICE_INIT = {
  currentPrice: 0,
  priceChange24h: 0,
  low24h: 0,
  high24h: 0,
  volume24h: 0,
  percentage: 0,
  buyPrice: 0,
  sellPrice: 0,
  pairName: '',
}
function formatSymbol(symbol) {
  return symbol?.replace('/', '')?.replace('-', '')?.toLowerCase();
}
export function usePricingMonitor(pairName) {
  const [pricingData, setPricingData] = useState(PRICE_INIT)
  const { markets } = useSelector((state) => state.crypto?.markets)

  const { state } = useContext(SocketContext)
  const { orderBooks, markets: marketWS } = state

  useEffect(() => {
    const foundMarket = marketWS && marketWS.find((x) => formatSymbol(x?.pairName) === formatSymbol(pairName))
    // console.log("foundMarketfoundMarket", foundMarket, JSON.stringify(foundMarket), marketWS );
    const sMarket = markets && markets.find((x) => formatSymbol(x?.pairName) === formatSymbol(pairName))
    // console.log("sMarketsMarket", sMarket, JSON.stringify(sMarket), markets);
    const foundOrderBook = orderBooks && orderBooks.find((x) => formatSymbol(x.pairName) === formatSymbol(pairName))
    const buyPrice =
    (foundOrderBook && foundOrderBook?.asks?.[0] && foundOrderBook?.asks?.[0]?.[0]) ||
    0
    const sellPrice =
    (foundOrderBook && foundOrderBook?.bids?.[0] && foundOrderBook?.bids?.[0]?.[0]) || 0
  
    if (foundMarket && sMarket) {
      // Destructure values from the first market data object (foundMarket)
      const {
        volume: foundVolume,
        high: foundHigh,
        low: foundLow,
        close: foundClose,
        open: foundOpen,
        last: foundLast,
        percentage: foundPercentage,
        instanceId: foundInstanceId,
        pairName: foundPairName
      } = foundMarket || {};
    
      // Destructure values from the second market data object (sMarket)
      const {
        volume: sVolume,
        marketPrice: sMarketPrice,
        percentage: sPercentage,
        open: sOpen,
        close: sClose,
        instanceId: sInstanceId,
        pairName: sPairName,
        currentPrice: sCurrentPrice,
      } = sMarket || {};
    
      // Combine the data with preference for foundMarket values
      const pricing = {
        volume24h: foundVolume || sVolume,
        percentage: foundPercentage || sPercentage,
        pairName: foundPairName || sPairName,
        isPositive: parseFloat(foundPercentage || sPercentage || 0) >= 0,
        high24h: foundHigh,
        low24h: foundLow,
        close: foundClose || sClose,
        open: foundOpen || sOpen,
        buyPrice,
        sellPrice,
        currentPrice: foundClose || sCurrentPrice  || foundLast || sMarketPrice,
        instanceId: foundInstanceId || sInstanceId
      };
    
      setPricingData(pricing);
    }
    if(sMarket && !foundMarket){
    
      // Destructure values from the second market data object (sMarket)
      const {
        volume: sVolume,
        marketPrice: sMarketPrice,
        percentage: sPercentage,
        open: sOpen,
        close: sClose,
        instanceId: sInstanceId,
        percentage: foundPercentage,
        pairName: sPairName
      } = sMarket || {};
    
      // Combine the data with preference for foundMarket values
      const pricing = {
        volume24h: sVolume,
        volume: sVolume,
        percentage: sPercentage || foundPercentage,
        pairName: sPairName,
        isPositive: parseFloat(sPercentage || foundPercentage || 0) >= 0,
        high24h: 0,
        low24h: 0,
        close: sClose,
        open: sOpen,
        buyPrice,
        sellPrice,
        currentPrice: sMarketPrice,
        instanceId: sInstanceId
      };
    
      setPricingData(pricing);
    }
  }, [ marketWS, pairName, markets, orderBooks])


  return pricingData
}
